"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDataAttr = void 0;
var tslib_1 = require("tslib");
exports.generateDataAttr = function (props, filter) {
    return Object.entries(props)
        .filter(function (_a) {
        var key = _a[0];
        return filter && filter.includes(key);
    })
        .reduce(function (output, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (tslib_1.__assign(tslib_1.__assign({}, output), (_b = {}, _b["data-" + key.toLowerCase()] = value, _b)));
    }, {});
};
//# sourceMappingURL=generateDataAttr.js.map